<template>
  <section class="primaryInfo">
    <a
      name="home"
      style="
        position: relative;
        top: -420px;
        display: block;
        height: 0;
        overflow: hidden;
      "
    ></a>
    <section class="information">
      <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
      <section class="innerBox">
        <div class="leftMenu">
          <li
            @click="gotoHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : '',
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ leftItem.title }}
          </li>
        </div>
        <div class="info">
          <ul class="crumbs_container">
            <li
              class="crumbs_item"
              v-for="(routeItem, routeIdx) in crumbsList"
              :key="routeIdx"
              @click="gotoHandle(routeItem.routeName)"
            >
              {{ routeItem.label }}
              <span v-if="routeIdx < crumbsList.length - 1">></span>
            </li>
          </ul>
          <p class="prevTips">
            You are currently viewing an archived version of the Privacy Policy.
            View the<a href="/privacy"> current version </a> or
            <a href="/archivedprivacy">all past versions</a>.
          </p>
          <h1>ToTok Privacy Policy</h1>
          <h3>Last updated: August 2019</h3>

          <p>
            <strong>TOTOK</strong> (<strong>"Totok"</strong>,
            <strong>"totok"</strong>, <strong>"we"</strong>,
            <strong>"us"</strong> or <strong>"our"</strong>) are committed to
            protecting and respecting your privacy. This policy sets out the
            basis on which any personal data we collect from you, or that you
            provide to us, through our instant messaging application ToTok
            (<strong>"ToTok"</strong> or the <strong>"App"</strong>), or any
            other service (together, the <strong>"Services"</strong>), will be
            processed by us. Please read the following carefully to understand
            our views and practices regarding your personal data and how we will
            treat it. For information regarding the general use of the Services,
            please see our Terms of Use https://totok.ai/terms.
          </p>
          <p>
            To the extent the General Data Protection Regulation (the
            <strong>"GDPR"</strong>) applies, the controller of your personal
            data is ToTok.
          </p>
          <p>
            If you wish to contact us with any questions in relation to this
            policy or our privacy practices, you may contact us in writing at
            the address given above or by emailing
            <a href="mailto:privacy@totok.ai">privacy@totok.ai</a>.
          </p>
          <p>
            We keep our privacy policy and practices under review and this
            policy was last updated on the date given above. Any changes to this
            policy will be posted online and, if possible, emailed to you.
          </p>
          <h2>
            Information we may collect from you
          </h2>
          <p>
            Personal data, or personal information, means any information about
            an individual from which that person can be identified.
          </p>
          <p>
            We may collect and process personal data when we provide the
            Services. The personal data we collect includes:
          </p>
          <ul>
            <li>
              <strong>Account data for the Application or other Services</strong
              >: mobile number, name, gender and date of birth;
            </li>
            <li>
              <strong>Contact data</strong>: postal address and email address;
            </li>
            <li>
              <strong>Technical and usage data</strong>: internet protocol (IP)
              address, your login data, browser type and version, time zone
              setting and location, browser plug-in types and versions,
              operating system and platform, and other technology on the devices
              you use to access this website.
            </li>
          </ul>
          <p>
            In order to be able to operate our App correctly and efficiently, we
            also require to collect the following personal data:
          </p>
          <ul>
            <li>
              <strong>Address book data</strong>: the contacts held in your
              device;
            </li>
            <li>
              <strong>Messages</strong>: all data is stored heavily encrypted so
              that local ToTok engineers or physical intruders cannot get
              access. Unless stated otherwise in this Privacy Policy, the
              personal data that you provide us will only be stored for as long
              as it is necessary for us to fulfill our obligations in respect of
              the provision of the Services.
            </li>
          </ul>
          <h2>
            When we collect this data
          </h2>
          <p>
            We may collect this information from you in the following ways:
          </p>
          <ul>
            <li>
              when you use any of our Services;
            </li>
            <li>
              to verify your account for any of our Services;
            </li>
            <li>
              when you contact us via the App, email, mail or telephone;
            </li>
            <li>
              when you give us feedback or otherwise contact us;
            </li>
            <li>
              from a third party also using our services who, for example, you
              send and receive messages; and
            </li>
            <li>
              from a third party service provider.
            </li>
          </ul>
          <p>
            As you interact with our App, we will also automatically collect the
            technical and usage data noted above about your equipment, messaging
            actions and patterns. We collect this personal data by using cookies
            and other similar technologies.
          </p>
          <h2>
            How we use your personal data
          </h2>
          <p>
            We use your personal data for the following reasons:
          </p>
          <ul>
            <li>
              to provide you with, and operate, the App;
            </li>
            <li>
              to provide you with our Services;
            </li>
            <li>
              to send you marketing materials;
            </li>
            <li>
              to respond to any of your queries.
            </li>
          </ul>
          <p>
            We only process your personal data when it is lawful for us to do
            so. We rely on the following lawful grounds to process your personal
            data:
          </p>
          <ul>
            <li>
              consent of the data subject;
            </li>
            <li>
              performance of a contract to which the data subject is party or in
              order to take steps at the request of the data subject prior to
              entering into a contract;
            </li>
            <li>
              compliance with a legal obligation to which the controller is
              subject;
            </li>
            <li>
              protect the vital interests of the data subject or of another
              natural person;
            </li>
            <li>
              performance of a task carried out in the public interest or in the
              exercise of official authority vested in the controller; and/or
            </li>
            <li>
              legitimate interests pursued by the controller or by a third
              party.
            </li>
          </ul>
          <h2>
            Sharing your personal data
          </h2>
          <p>
            We may share your personal data in the following scenarios:
          </p>
          <ul>
            <li>
              we may share your personal data with your consent;
            </li>
            <li>
              we may share your personal data with other users who are using the
              App;
            </li>
            <li>
              we may share your personal data with certain service providers to
              help us provide the best services to you and others.
            </li>
            <li>
              We may share your personal data if we are required to respond to
              law enforcement, officials, regulatory agencies and other lawful
              requests or legal processes, or to comply with a legal obligation
              to which we are subject; and/or
            </li>
            <li>
              We may share your personal data with group companies.
            </li>
          </ul>
          <p>
            If we are required to transfer your personal data to a country
            outside that in which we collected it, we will do so in accordance
            with the applicable data privacy legislation.
          </p>
          <h2>
            Security of your personal data
          </h2>
          <p>
            We take your privacy very seriously and work hard to protect your
            data from being accidentally lost, used or accessed in an
            unauthorised way, altered or disclosed. We have put in place
            appropriate security measures to prevent this from happening.
          </p>
          <p>
            To learn more about our security and privacy features, please visit
            <a href="https://totok.ai/security">here</a>.
          </p>
          <p>
            Unfortunately, the transmission of information via the internet is
            not completely secure. Although we will do our best to protect your
            personal data, we cannot guarantee the security of your data
            transmitted to our site; any transmission is at your own risk. Once
            we have received your information, we will use strict procedures and
            security features to try to prevent your data from being
            accidentally lost, used or accessed in an unauthorised way, altered
            or disclosed.
          </p>
          <h2>
            How long we keep your personal data for
          </h2>
          <p>
            We will only retain your personal data for as long as reasonably
            necessary to fulfil the purposes we collected it for, including for
            the purposes of satisfying any legal, regulatory, tax, accounting or
            reporting requirements. We may retain your personal data for a
            longer period in the event of a complaint or if we reasonably
            believe there is a prospect of litigation in respect to our
            relationship with you.
          </p>
          <p>
            To determine the appropriate retention period for personal data, we
            consider the amount, nature and sensitivity of the personal data,
            the potential risk of harm from unauthorised use or disclosure of
            your personal data, the purposes for which we process your personal
            data and whether we can achieve those purposes through other means,
            and the applicable legal, regulatory, tax, accounting or other
            requirements.
          </p>
          <h2>
            Your Rights
          </h2>
          <p>
            In certain circumstances, you may have the right to:
          </p>
          <ul>
            <li>
              <strong>Request access</strong> to your personal data (commonly
              known as a "data subject access request"). This enables you to
              receive a copy of the personal data we hold about you and to check
              that we are lawfully processing it.
            </li>
            <li>
              <strong>Request correction</strong> of the personal data that we
              hold about you. This enables you to have any incomplete or
              inaccurate data we hold about you corrected, though we may need to
              verify the accuracy of the new data you provide to us.
            </li>
            <li>
              <strong>Request erasure</strong> of your personal data. This
              enables you to ask us to delete or remove personal data where
              there is no good reason for us continuing to process it. You also
              have the right to ask us to delete or remove your personal data
              where you have successfully exercised your right to object to
              processing (see below), where we may have processed your
              information unlawfully or where we are required to erase your
              personal data to comply with local law.
            </li>
            <li>
              <strong>Object to processing</strong> of your personal data where
              we are relying on a legitimate interest (or those of a third
              party) and there is something about your particular situation
              which makes you want to object to processing on this ground as you
              feel it impacts on your fundamental rights and freedoms. You also
              have the right to object where we are processing your personal
              data for direct marketing purposes.
            </li>
            <li>
              <strong>Request restriction of processing</strong> of your
              personal data. This enables you to ask us to suspend the
              processing of your personal data in certain scenarios.
            </li>
            <li>
              <strong>Request the transfer</strong> of your personal data to you
              or to a third party. We will provide to you, or a third party you
              have chosen, your personal data in a structured, commonly used,
              machine-readable format.
            </li>
            <li>
              <strong>Withdraw consent</strong> at any time where we are relying
              on consent to process your personal data.
            </li>
            <li>
              <strong>Complain</strong> to the appropriate regulator for any
              data protection issues. We would, however appreciate the chance to
              deal with your concerns before you approach the regulator so
              please contact us in the first instance.
            </li>
          </ul>
          <p>
            To exercise one of the above rights, please contact us using the
            details provided above.
          </p>
          <p>
            We may need to request specific information from you to help us
            confirm your identity and ensure your right to access your personal
            data (or to exercise any of your other rights). This is a security
            measure to ensure that personal data is not disclosed to any person
            who has no right to receive it. We may also contact you to ask you
            for further information in relation to your request to speed up our
            response.
          </p>
          <p>
            We try to respond to all legitimate requests within one month.
            Occasionally it could take us longer than a month if your request is
            particularly complex or you have made a number of requests. In this
            case, we will notify you and keep you updated.
          </p>
          <h2>
            Third party links
          </h2>
          <p>
            Our Services may include links to third-party websites, plug-ins and
            applications. Clicking on those links or enabling those connections
            may allow third parties to collect or share data about you. We do
            not control these third-party websites, plug-ins and/or applications
            and are not responsible for their privacy statements. When you leave
            our App, we encourage you to read the privacy policy of every
            website or application you visit or use.
          </p>
        </div>
      </section>
    </section>

    <Footer style="margin-top: 40px;"></Footer>
    <FootBanner></FootBanner>
  </section>
</template>

<script>
import NavCrumbs from "@/components/NavCrumbs.vue";

import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  metaInfo() {
    return {
      title: "Privacy Policy - ToTok Messenger",
      meta: [
        {
          Description:
            "To check how ToTok collect and process your data, please read our privacy policy carefully",
        },
        { property: "og:title", content: "Privacy Policy - ToTok Messenger" },
        { property: "og:url", content: "https://totok.ai/privacy" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        {
          property: "og:description",
          content:
            "Enjoy FREE, FAST and FUN calling with your family and friends.",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NavCrumbs,
    Footer,
    FootBanner,
  },
  data() {
    return {
      crumbProp: {
        label: "Privacy & Terms",
        type: "simple",
      },
      archivedVersionLabel: "(archived versions)",

      mainPannel: "",
      showinfo: false,
      isActive: "privacy",
      leftMenus: [
        {
          title: "Terms of Use",
          anchorId: "terms",
        },
        {
          title: "Privacy Policy",
          anchorId: "privacy",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
    crumbsList() {
      return [
        {
          label: "Privacy & Terms",
          routeName: "privacy",
        },
        {
          label: "Updates: Privacy Policy",
          routeName: "archivedprivacy",
        },
        {
          label: "Auguest 2019",
          anchorId: "privacy-dec29",
        },
      ];
    },
  },
  methods: {
    gotoHandle(routeName) {
      this.$router.push({
        name: routeName,
      });
    },
  },
  mounted() {
    this.mainPannel = document.getElementById("mainbox");
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .primaryInfo {
        // padding: 0.8rem;
        background: #fff;
        height: 82vh;

        div {
            margin-left 20px
            margin-right 20px
        }

        .leftMenu {
            display none
        }

        .info {

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                // padding-top: 40px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
            .crumbs_container{
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                list-style: none;
                margin-left: 0px;
                padding-top: 20px;
                .crumbs_item{
                    color:#4377f2;
                    font-size:12px;
                    cursor pointer;
                    margin-left:10px;
                    span{
                        margin-left:10px;
                        color: #808080;
                    }
                }
                .crumbs_item:nth-child(1){
                    margin-left: 0px;
                }
                .crumbs_item:nth-last-child(1){
                    color: #808080;
                }
            }
            .prevTips{
                background: #e1e1e1;
                padding: 10px;
                border-radius: 4px;
            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 102px;
        width: 100vw;
        background: #fff;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                width:800px;
                min-height: 83vh;
                overflow: auto;

                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: flex-start;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
            width: 620px;
            margin: 20px 0;

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
            .crumbs_container{
                display: none;
            }
            .prevTips{
                background: #e1e1e1;
                padding: 10px;
                border-radius: 4px;
            }
        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
